import React from 'react';
import { Button, FormFeedback, Input, Modal, ModalBody, ModalHeader } from 'reactstrap';

export const CreateRenameFolderModal = props => {
	const { isOpen, setIsOpen, isEdit, form, setFolder } = props;

	return (
		<Modal
			isOpen={isOpen}
			toggle={() => {
				setFolder(null);
				setIsOpen(!isOpen);
			}}
			id='createFolderModal'
			size='sm'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
			tabIndex='-1'
		>
			<ModalHeader
				id='createFolderModalLabel'
				toggle={() => {
					setFolder(null);
					setIsOpen(!isOpen);
				}}
			>
				{' '}
				{isEdit ? 'Renombrar Carpeta' : 'Crear Carpeta'}{' '}
			</ModalHeader>
			<ModalBody>
				<form
					autoComplete='off'
					className='needs-validation createfolder-form'
					id='createfolder-form'
					noValidate=''
					onSubmit={e => {
						e.preventDefault();
						form.handleSubmit();
						return false;
					}}
				>
					<div className='mb-4'>
						<label htmlFor='foldername-input' className='form-label'>
							Nombre de la Carpeta
						</label>
						<Input
							type='text'
							className='form-control'
							id='foldername-input'
							name='name'
							placeholder='Enter folder name'
							validate={{
								required: { value: true },
							}}
							onChange={form.handleChange}
							onBlur={form.handleBlur}
							value={form.values.name || ''}
							invalid={
								form.touched.name && form.errors.name ? true : false
							}
						/>
						{form.touched.name && form.errors.name ? (
							<FormFeedback type='invalid'>
								{form.errors.name}
							</FormFeedback>
						) : null}
					</div>
					<div className='hstack gap-2 justify-content-end'>


						<Button className='btn-danger btn-label' onClick={() => {
							setFolder(null);
							setIsOpen(!isOpen);
						}}><i className='icon-x label-icon'></i> Cancelar</Button>
						
						<button type='submit' className='btn btn-label btn-primary'><i className={`${Icons.plus} label-icon`}></i> {isEdit ? 'Guardar' : 'Agregar Carpeta'}</button>
					</div>
				</form>
			</ModalBody>
		</Modal>
	);
};
